// @flow
export { default } from "./Svg";
